import { Tv, Film, CalendarClock } from "lucide-react";
import { useStore } from "@/lib/store";
import AccountForm from "@/components/AccountForm";

export default function Onboarding() {
  const { addAccount } = useStore();
  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr] bg-[#08090E]" data-testid="onboarding">
      <div className="relative hidden lg:block overflow-hidden">
        <img src="https://images.pexels.com/photos/12838778/pexels-photo-12838778.jpeg?auto=compress&cs=tinysrgb&w=1600" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#08090E]" />
        <div className="absolute bottom-16 left-14 max-w-md xc-rise">
          <div className="xc-label text-[#00E5FF]">Windows · Xtream Codes</div>
          <h1 className="font-heading text-5xl font-extrabold tracking-tight mt-3 leading-[1.05]">Your IPTV, on your desktop.</h1>
          <div className="flex gap-6 mt-8 text-sm text-slate-400">
            <span className="flex items-center gap-2"><Tv className="w-4 h-4 text-[#E50914]" /> Live TV</span>
            <span className="flex items-center gap-2"><Film className="w-4 h-4 text-[#E50914]" /> Movies & series</span>
            <span className="flex items-center gap-2"><CalendarClock className="w-4 h-4 text-[#E50914]" /> TV guide</span>
          </div>
        </div>
      </div>
      <div className="flex items-center px-8 sm:px-16 py-16">
        <div className="w-full max-w-md xc-rise" style={{ animationDelay: "120ms" }}>
          <img src="/icon-192.png" alt="" className="w-12 h-12 rounded-xl mb-8" />
          <h2 className="font-heading text-3xl font-bold tracking-tight">Add your playlist</h2>
          <p className="text-sm text-slate-400 mt-2 mb-8">
            Enter the Xtream Codes details from your IPTV provider. They're saved only on this computer.
          </p>
          <AccountForm onSave={addAccount} />
        </div>
      </div>
    </div>
  );
}
